/* unplugin-vue-components disabled */import { render } from "./CallRecordListView.vue?vue&type=template&id=a671f61e&scoped=true"
import script from "./CallRecordListView.vue?vue&type=script&lang=js"
export * from "./CallRecordListView.vue?vue&type=script&lang=js"

import "./CallRecordListView.vue?vue&type=style&index=0&id=a671f61e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a671f61e"]])

export default __exports__